import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import {
  Paper as MuiPaper,
  Alert,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ILogicalCheck } from "../../../../types/contract";
import OwlAvatarIcon from "../../../../icons/OwlAvatarIcon";

const UploadButton = styled(MuiPaper)`
  height: 144px;
  border: 1px dashed ${(props) => props.theme.palette.divider};
  padding: 24px;
  cursor: pointer;
  &:hover {
    border: 1px dashed ${(props) => props.theme.palette.primary.main};
  }
`;

const LogicalCheckAlert = ({
  logicalCheck,
}: {
  logicalCheck: ILogicalCheck;
}) => {
  const { t, i18n } = useTranslation();

  if (!logicalCheck || logicalCheck.logic_check?.is_logical === true) {
    return <span />;
  }

  return (
    <Alert
      severity={
        logicalCheck.logic_check?.is_logical === false
          ? "error"
          : logicalCheck.logic_check?.is_logical
          ? "success"
          : "info"
      }
      sx={{
        width: "100%",
        marginBottom: 2,
      }}
    >
      {logicalCheck.logic_check?.explanation}

      <List dense>
        {logicalCheck.errors?.map((e) => (
          <ListItem disableGutters disablePadding>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <OwlAvatarIcon />
            </ListItemIcon>
            <ListItemText primary={e.detail} />
          </ListItem>
        ))}

        {logicalCheck.risks?.map((r) => (
          <ListItem disableGutters disablePadding>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <OwlAvatarIcon />
            </ListItemIcon>
            <ListItemText primary={r.detail} />
          </ListItem>
        ))}
      </List>
    </Alert>
  );
};

export default LogicalCheckAlert;
